/*
 * @Author: zhengxiaowen
 * @Date: 2018-09-25 16:42:20
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-12-01 10:43:28
 */

let _type = process.env.NODE_ENV !== 'production' ? 'local' : 'prod'

let _baseUrl = window.location.protocol + "//" + window.location.hostname + (!!!window.location.port ? "" : ":" + window.location.port)
let platform = {}

switch (_type) {
  case 'local':
    platform.root = 'http://10.10.2.15:9001'
    platform.webSocketHost = 'http://10.10.2.15:9001'
    break
  default:
    platform.root = _baseUrl
    break
}

platform.type = _type
platform.host = platform.root + '/api'
platform.url = {
    zuulBaseServer: platform.host + "/zuul/baseServer",
    baseServer: platform.host + "/baseServer",
    scheduleServer: platform.host + "/schedule",
    exportServer: platform.host + "/exportServer",
    messageServer: platform.host + "/messageServer",
    bpmServer: platform.host + "/bpmServer",
    ruleEngineServer: platform.host + "/ruleEngineServer",
    fileServer: platform.host + "/fileServer",
    webSocketServer: platform.webSocketHost + "/srm-ws",
    srmServer: platform.host + "/srmServer",

    /*连接本地服务器在此处添加链接*/
    // baseServer: "http://127.0.0.1:9002",
    // fileServer: "http://127.0.0.1:9003",
    // srmServer: "http://127.0.0.1:19028",
    //scheduleServer: "http://127.0.0.1:19006",

}

platform.systemCode = 'MOBILE'
platform.systemName = "SAAF移动系统"
// 设置是否启用复杂密码
platform.complexityPwd = true

export default platform



// WEBPACK FOOTER //
// ./src/config/platform.js